/* tslint:disable */
/* eslint-disable */
/**
 * EVE Swagger Interface
 * An OpenAPI for EVE Online
 *
 * The version of the OpenAPI document: 1.30
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 200 ok object
 * @export
 * @interface GetDogmaAttributesAttributeIdOk
 */
export interface GetDogmaAttributesAttributeIdOk {
    /**
     * attribute_id integer
     * @type {number}
     * @memberof GetDogmaAttributesAttributeIdOk
     */
    attributeId: number;
    /**
     * default_value number
     * @type {number}
     * @memberof GetDogmaAttributesAttributeIdOk
     */
    defaultValue?: number;
    /**
     * description string
     * @type {string}
     * @memberof GetDogmaAttributesAttributeIdOk
     */
    description?: string;
    /**
     * display_name string
     * @type {string}
     * @memberof GetDogmaAttributesAttributeIdOk
     */
    displayName?: string;
    /**
     * high_is_good boolean
     * @type {boolean}
     * @memberof GetDogmaAttributesAttributeIdOk
     */
    highIsGood?: boolean;
    /**
     * icon_id integer
     * @type {number}
     * @memberof GetDogmaAttributesAttributeIdOk
     */
    iconId?: number;
    /**
     * name string
     * @type {string}
     * @memberof GetDogmaAttributesAttributeIdOk
     */
    name?: string;
    /**
     * published boolean
     * @type {boolean}
     * @memberof GetDogmaAttributesAttributeIdOk
     */
    published?: boolean;
    /**
     * stackable boolean
     * @type {boolean}
     * @memberof GetDogmaAttributesAttributeIdOk
     */
    stackable?: boolean;
    /**
     * unit_id integer
     * @type {number}
     * @memberof GetDogmaAttributesAttributeIdOk
     */
    unitId?: number;
}

/**
 * Check if a given object implements the GetDogmaAttributesAttributeIdOk interface.
 */
export function instanceOfGetDogmaAttributesAttributeIdOk(value: object): value is GetDogmaAttributesAttributeIdOk {
    if (!('attributeId' in value) || value['attributeId'] === undefined) return false;
    return true;
}

export function GetDogmaAttributesAttributeIdOkFromJSON(json: any): GetDogmaAttributesAttributeIdOk {
    return GetDogmaAttributesAttributeIdOkFromJSONTyped(json, false);
}

export function GetDogmaAttributesAttributeIdOkFromJSONTyped(json: any, ignoreDiscriminator: boolean): GetDogmaAttributesAttributeIdOk {
    if (json == null) {
        return json;
    }
    return {
        
        'attributeId': json['attribute_id'],
        'defaultValue': json['default_value'] == null ? undefined : json['default_value'],
        'description': json['description'] == null ? undefined : json['description'],
        'displayName': json['display_name'] == null ? undefined : json['display_name'],
        'highIsGood': json['high_is_good'] == null ? undefined : json['high_is_good'],
        'iconId': json['icon_id'] == null ? undefined : json['icon_id'],
        'name': json['name'] == null ? undefined : json['name'],
        'published': json['published'] == null ? undefined : json['published'],
        'stackable': json['stackable'] == null ? undefined : json['stackable'],
        'unitId': json['unit_id'] == null ? undefined : json['unit_id'],
    };
}

export function GetDogmaAttributesAttributeIdOkToJSON(json: any): GetDogmaAttributesAttributeIdOk {
    return GetDogmaAttributesAttributeIdOkToJSONTyped(json, false);
}

export function GetDogmaAttributesAttributeIdOkToJSONTyped(value?: GetDogmaAttributesAttributeIdOk | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'attribute_id': value['attributeId'],
        'default_value': value['defaultValue'],
        'description': value['description'],
        'display_name': value['displayName'],
        'high_is_good': value['highIsGood'],
        'icon_id': value['iconId'],
        'name': value['name'],
        'published': value['published'],
        'stackable': value['stackable'],
        'unit_id': value['unitId'],
    };
}

